// extracted by mini-css-extract-plugin
export default {"Header":"LoginHeader_Header__ziF0Z"};